<template>
    <div>
      <header>
        <section class="hero">
          <div class="hero-content">
            <img src="@/assets/icon.jpg" alt="Gogo Saporu" class="bot-icon" />
            <h1>Bienvenido a Gogo Saporu</h1>
            <p>Ya con <span>{{ formattedMembers }}</span> creyentes</p>
            <button @click="navigateTo('/condena')" class="discord-btn">
              ¿Quieres unirte a ellos?
            </button>
          </div>
        </section>
      </header>

      <div class="page-container">
        <h2>¡Feliz Año Nuevo, Gogo Amigos!</h2>
        <h3>Por un 2025 bien wa</h3>
        <img src="../assets/crupier.jpg" alt="Logo" class="error-image" />
        <button @click="navigateTo('/gogopoints')" class="discord-btn">
          Los Gogo Points se acercan
        </button>
      </div>
  
      <section class="features">
        <h2>¿Por qué elegir a Gogo?</h2>
        <div class="feature-block">
          <div class="features-text">
            <h3>Es la Mera Verga</h3>
            <ul>
              <li>Responde rápido</li>
              <li>Promueve el respeto</li>
              <li>Odia a Humori</li>
              <li>Hace falta decir más?</li>
              <li>Claro que no</li>
            </ul>
          </div>
          <img src="@/assets/gogo_grosero.png" alt="Chat del Bot" class="chat-image" />
        </div>
        <div class="feature-block">
          <button @click="navigateTo('/dev')" class="discord-btn">
            Sobre nosotros
          </button>
        </div>
      </section>
    </div>
  </template>
  
  <script>
  import { useRouter } from 'vue-router';
  import { ref, computed, onMounted } from 'vue';

  
  export default {
    setup() {
      const router = useRouter();
      const members = ref(0);
  
      const navigateTo = (path) => {
        router.push(path);
      };
  
      onMounted(() => {
        const randomNumber = Math.floor(Math.random() * (999999999 - 1000000 + 1)) + 1000000;
        members.value = randomNumber;
      });
  
      const formattedMembers = computed(() => members.value.toLocaleString());
  
      return { members, formattedMembers, navigateTo };
    },
  };
  </script>
  
  <style>
  /* Aquí irían los estilos específicos */
  .chat-image {
    width: 100%;
    max-width: 400px;
  }
  </style>  